<template>
  <GlobalWrapper>
    <!-- Page heading component -->
    <div class="md:flex md:items-center md:justify-between py-8">
      <div class="min-w-0 flex-1">
        <h2
          class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight"
        >
          NPO Account Setup
        </h2>
      </div>
    </div>

    <!-- Step 1: Create Account -->
    <div class="w-8/12 px-16 py-8 relative bg-gray-100">
      <div class="w-full pb-8">
        <div class="flex">
          <h2 class="text-xl font-bold tracking-tight text-gray-900">Create Your Account</h2>
          <div class="text-right ml-auto">
            <p>Already have an account?</p>
            <RouterLink to="/login" class="text-primary hover:underline" data-cy="login">
              Log in
            </RouterLink>
          </div>
        </div>
      </div>

      <form class="" @submit.prevent="attemptUserRegistration()">
        <div class="w-6/12 relative">
          <InputField
            v-model:value="form.firstName.value"
            :errors="form.firstName.errors"
            @blur="form.firstName.validate()"
            label="First Name"
            placeholder="Enter first name..."
          />

          <InputField
            v-model:value="form.lastName.value"
            :errors="form.lastName.errors"
            @blur="form.lastName.validate()"
            label="Last Name"
            placeholder="Enter last name..."
          />

          <InputField
            v-model:value="form.email.value"
            :errors="form.email.errors"
            @blur="form.email.validate()"
            type="email"
            label="Email"
            placeholder="Enter email..."
          />

          <InputField
            v-model:value="form.password.value"
            :errors="form.password.errors"
            @blur="form.password.validate()"
            type="password"
            label="Password"
            placeholder="Enter password..."
          />
        </div>
        <div class="flex">
          <button
            class="ml-auto inline-flex items-center mt-4 rounded-md border border-transparent bg-primary px-6 py-3 text-base text-white shadow-sm hover:bg-primaryDark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
            type="submit"
          >
            Next
          </button>
        </div>
      </form>
    </div>
  </GlobalWrapper>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { SignupForm, UserApi } from '@/services/users/'
import InputField from '@/components/inputs/InputField'
import SelectField from '@/components/inputs/SelectField'
import GlobalWrapper from '@/components/GlobalWrapper.vue'
import { CheckIcon, LockClosedIcon } from '@heroicons/vue/20/solid'

export default {
  name: 'Signup',
  components: {
    InputField,
    SelectField,
    GlobalWrapper,
    CheckIcon,
    LockClosedIcon,
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const form = ref(new SignupForm())

    async function handleRegistrationSuccess(user) {
      await store.dispatch('setUser', user)
      const redirectPath = router.currentRoute.value.query.redirect
      if (redirectPath) {
        router.push({ path: redirectPath })
      } else {
        router.push({ name: 'CampaignList' })
      }
    }

    function handleRegistrationFailure(error) {
      alert(error)
    }

    function attemptUserRegistration() {
      // unwrap form
      const unwrappedForm = form.value
      unwrappedForm.validate()
      if (!unwrappedForm.isValid) return

      UserApi.create({
        firstName: unwrappedForm.firstName.value,
        lastName: unwrappedForm.lastName.value,
        email: unwrappedForm.email.value,
        password: unwrappedForm.password.value,
      })
        .then(handleRegistrationSuccess)
        .catch(handleRegistrationFailure)
    }

    return {
      form,
      attemptUserRegistration,
    }
  },
}
</script>
